class BESSAppSessionAPIService extends BESSAppAPIServiceBase {

    constructor(parent) {
        super(parent, 'session/');
    }
    apiUpdateTheme(theme, onSaved, onError = null) {
        this._post('theme', {
            data: {'theme': theme},
            onResult: onSaved,
            onError: onError,
        });
    }

    apiUpdateSidebar(collapsed, onSaved, onError = null) {
        this._post('sidebar', {
            data: {'collapsed': collapsed},
            onResult: onSaved,
            onError: onError,
        });
    }
}